import { Icon as IconifyIcon } from '@iconify/react';

interface IconProps {
  /** Iconify icon ID, e.g. "streamline:home-1". */
  name: string;
  /** Pixel size — width and height. Defaults to 16. */
  size?: number;
  /** Tailwind classes — typically text-* for colour, h-* w-* for size. */
  className?: string;
  /** Aria label for screen readers. Defaults to decorative (aria-hidden). */
  'aria-label'?: string;
}

/**
 * Wrapper around @iconify/react that the rest of the codebase imports from.
 * All icon IDs come from the Streamline Core set (Ascend brand pack).
 *
 * Color: pass via className (e.g. `text-primary`) — Iconify icons use
 * currentColor by default.
 *
 * Size precedence: when a className contains h-* / w-* utilities, those win
 * over the `size` prop because Tailwind utilities override inline width/height.
 */
export function Icon({ name, size = 16, className, 'aria-label': ariaLabel }: IconProps) {
  return (
    <IconifyIcon
      icon={name}
      width={size}
      height={size}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    />
  );
}
